import * as t from 'io-ts'

export const TAuthResponse = t.strict({ accessToken: t.string })
